import script from "./OtherPreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtherPreferences.vue?vue&type=script&setup=true&lang=ts"

import "./OtherPreferences.vue?vue&type=style&index=0&id=769a94ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769a94ea"]])

export default __exports__